'use strict';

var jsxRuntime = require('react/jsx-runtime');
var SmallArrowDown = require('./Icons/Small/SmallArrowDown.js');
var SmallArrowLeft = require('./Icons/Small/SmallArrowLeft.js');
var SmallArrowRight = require('./Icons/Small/SmallArrowRight.js');
var SmallArrowUp = require('./Icons/Small/SmallArrowUp.js');
var SmallCheck = require('./Icons/Small/SmallCheck.js');
var SmallIndeterminate = require('./Icons/Small/SmallIndeterminate.js');
var SmallPlus = require('./Icons/Small/SmallPlus.js');
var SmallRadioDot = require('./Icons/Small/SmallRadioDot.js');
var SmallCamera = require('./Icons/Small/SmallCamera.js');
var SmallDelete = require('./Icons/Small/SmallDelete.js');
var SmallResizer = require('./Icons/Small/SmallResizer.js');
var SmallInformation = require('./Icons/Small/SmallInformation.js');
var SmallEdit = require('./Icons/Small/SmallEdit.js');
var SmallPrivate = require('./Icons/Small/SmallPrivate.js');
var SmallScrap = require('./Icons/Small/SmallScrap.js');
var SmallPublic = require('./Icons/Small/SmallPublic.js');
var SmallHeart = require('./Icons/Small/SmallHeart.js');
var SmallStar = require('./Icons/Small/SmallStar.js');
var SmallWait = require('./Icons/Small/SmallWait.js');
var SmallMoreOptions = require('./Icons/Small/SmallMoreOptions.js');
var SmallEye = require('./Icons/Small/SmallEye.js');
var SmallTrash = require('./Icons/Small/SmallTrash.js');
var SmallShare = require('./Icons/Small/SmallShare.js');
var SmallLink = require('./Icons/Small/SmallLink.js');
var SmallBell = require('./Icons/Small/SmallBell.js');
var SmallCollection = require('./Icons/Small/SmallCollection.js');
var SmallLike = require('./Icons/Small/SmallLike.js');
var SmallList = require('./Icons/Small/SmallList.js');
var SmallPlay = require('./Icons/Small/SmallPlay.js');
var SmallStop = require('./Icons/Small/SmallStop.js');
var SmallSlash = require('./Icons/Small/SmallSlash.js');
var SmallCat = require('./Icons/Small/SmallCat.js');
var MediumArrowDown = require('./Icons/Medium/MediumArrowDown.js');
var MediumArrowLeft = require('./Icons/Medium/MediumArrowLeft.js');
var MediumArrowRight = require('./Icons/Medium/MediumArrowRight.js');
var MediumArrowUp = require('./Icons/Medium/MediumArrowUp.js');
var MediumCautionTriangle = require('./Icons/Medium/MediumCautionTriangle.js');
var MediumDelete = require('./Icons/Medium/MediumDelete.js');
var MediumEdit = require('./Icons/Medium/MediumEdit.js');
var MediumInformation = require('./Icons/Medium/MediumInformation.js');
var MediumPersonAdd = require('./Icons/Medium/MediumPersonAdd.js');
var MediumPlus = require('./Icons/Medium/MediumPlus.js');
var MediumEye = require('./Icons/Medium/MediumEye.js');
var MediumBubble = require('./Icons/Medium/MediumBubble.js');
var MediumCheck = require('./Icons/Medium/MediumCheck.js');
var MediumCalendar = require('./Icons/Medium/MediumCalendar.js');
var MediumEyeSlash = require('./Icons/Medium/MediumEyeSlash.js');
var MediumFilter = require('./Icons/Medium/MediumFilter.js');
var MediumReset = require('./Icons/Medium/MediumReset.js');
var MediumSuccess = require('./Icons/Medium/MediumSuccess.js');
var MediumCaution = require('./Icons/Medium/MediumCaution.js');
var MediumWait = require('./Icons/Medium/MediumWait.js');
var MediumError = require('./Icons/Medium/MediumError.js');
var MediumMenuDown = require('./Icons/Medium/MediumMenuDown.js');
var MediumMenuUp = require('./Icons/Medium/MediumMenuUp.js');
var MediumHeart = require('./Icons/Medium/MediumHeart.js');
var MediumHighlight = require('./Icons/Medium/MediumHighlight.js');
var MediumMoreOptions = require('./Icons/Medium/MediumMoreOptions.js');
var MediumRename = require('./Icons/Medium/MediumRename.js');
var MediumPin = require('./Icons/Medium/MediumPin.js');
var MediumTrash = require('./Icons/Medium/MediumTrash.js');
var MediumHashTag = require('./Icons/Medium/MediumHashTag.js');
var MediumMagic = require('./Icons/Medium/MediumMagic.js');
var MediumStar = require('./Icons/Medium/MediumStar.js');
var MediumShare = require('./Icons/Medium/MediumShare.js');
var MediumAi = require('./Icons/Medium/MediumAi.js');
var MediumGlassesMinus = require('./Icons/Medium/MediumGlassesMinus.js');
var MediumGlassesPlus = require('./Icons/Medium/MediumGlassesPlus.js');
var MediumUpload = require('./Icons/Medium/MediumUpload.js');
var MediumSend = require('./Icons/Medium/MediumSend.js');
var MediumPopular = require('./Icons/Medium/MediumPopular.js');
var MediumScrap = require('./Icons/Medium/MediumScrap.js');
var MediumLink = require('./Icons/Medium/MediumLink.js');
var MediumSearch = require('./Icons/Medium/MediumSearch.js');
var MediumMinus = require('./Icons/Medium/MediumMinus.js');
var MediumAnswer = require('./Icons/Medium/MediumAnswer.js');
var MediumCollection = require('./Icons/Medium/MediumCollection.js');
var MediumCompass = require('./Icons/Medium/MediumCompass.js');
var MediumFire = require('./Icons/Medium/MediumFire.js');
var MediumList = require('./Icons/Medium/MediumList.js');
var MediumPrivate = require('./Icons/Medium/MediumPrivate.js');
var MediumPublic = require('./Icons/Medium/MediumPublic.js');
var MediumQuestion = require('./Icons/Medium/MediumQuestion.js');
var MediumQuestionNew = require('./Icons/Medium/MediumQuestionNew.js');
var MediumBell = require('./Icons/Medium/MediumBell.js');
var MediumReply = require('./Icons/Medium/MediumReply.js');
var LargeAccountSetting = require('./Icons/Large/LargeAccountSetting.js');
var LargeDelete = require('./Icons/Large/LargeDelete.js');
var LargeService = require('./Icons/Large/LargeService.js');
var LargeUserImageAvatar = require('./Icons/Large/LargeUserImageAvatar.js');
var LargeArrowLeft = require('./Icons/Large/LargeArrowLeft.js');
var LargeArrowRight = require('./Icons/Large/LargeArrowRight.js');
var LargeBell = require('./Icons/Large/LargeBell.js');
var LargeDrawer = require('./Icons/Large/LargeDrawer.js');
var LargeFilter = require('./Icons/Large/LargeFilter.js');
var LargeSearch = require('./Icons/Large/LargeSearch.js');
var LargeArrowDown = require('./Icons/Large/LargeArrowDown.js');
var LargeArrowUp = require('./Icons/Large/LargeArrowUp.js');
var LargePlus = require('./Icons/Large/LargePlus.js');
var LargeHeart = require('./Icons/Large/LargeHeart.js');
var LargeStar = require('./Icons/Large/LargeStar.js');
var LargeShare = require('./Icons/Large/LargeShare.js');
var LargeSend = require('./Icons/Large/LargeSend.js');
var LargeReset = require('./Icons/Large/LargeReset.js');
var LargeCollection = require('./Icons/Large/LargeCollection.js');
var LargeCollectionAdd = require('./Icons/Large/LargeCollectionAdd.js');
var LargeAnswer = require('./Icons/Large/LargeAnswer.js');
var LargeLike = require('./Icons/Large/LargeLike.js');
var LargeQuestion = require('./Icons/Large/LargeQuestion.js');
var LargeScrap = require('./Icons/Large/LargeScrap.js');
var LargeBubble = require('./Icons/Large/LargeBubble.js');
var LargeHome = require('./Icons/Large/LargeHome.js');
var LargeLink = require('./Icons/Large/LargeLink.js');
var LargeTop = require('./Icons/Large/LargeTop.js');
var SocialFacebook = require('./Icons/Social/SocialFacebook.js');
var SocialGoogle = require('./Icons/Social/SocialGoogle.js');
var WishketFacebook = require('./Icons/Social/WishketFacebook.js');
var WishketBlog = require('./Icons/Social/WishketBlog.js');
var WishketNaverBlog = require('./Icons/Social/WishketNaverBlog.js');
var SocialX = require('./Icons/Social/SocialX.js');
var SocialNaver = require('./Icons/Social/SocialNaver.js');
var SocialLinkedIn = require('./Icons/Social/SocialLinkedIn.js');

const smallIcons = new Map([
    [
        'small_check',
        (props)=>jsxRuntime.jsx(SmallCheck, Object.assign({}, props))
    ],
    [
        'small_indeterminate',
        (props)=>jsxRuntime.jsx(SmallIndeterminate, Object.assign({}, props))
    ],
    [
        'small_plus',
        (props)=>jsxRuntime.jsx(SmallPlus, Object.assign({}, props))
    ],
    [
        'small_radio_dot',
        (props)=>jsxRuntime.jsx(SmallRadioDot, Object.assign({}, props))
    ],
    [
        'small_arrow_left',
        (props)=>jsxRuntime.jsx(SmallArrowLeft, Object.assign({}, props))
    ],
    [
        'small_arrow_right',
        (props)=>jsxRuntime.jsx(SmallArrowRight, Object.assign({}, props))
    ],
    [
        'small_arrow_down',
        (props)=>jsxRuntime.jsx(SmallArrowDown, Object.assign({}, props))
    ],
    [
        'small_arrow_up',
        (props)=>jsxRuntime.jsx(SmallArrowUp, Object.assign({}, props))
    ],
    [
        'small_camera',
        (props)=>jsxRuntime.jsx(SmallCamera, Object.assign({}, props))
    ],
    [
        'small_delete',
        (props)=>jsxRuntime.jsx(SmallDelete, Object.assign({}, props))
    ],
    [
        'small_resizer',
        (props)=>jsxRuntime.jsx(SmallResizer, Object.assign({}, props))
    ],
    [
        'small_information',
        (props)=>jsxRuntime.jsx(SmallInformation, Object.assign({}, props))
    ],
    [
        'small_wait',
        (props)=>jsxRuntime.jsx(SmallWait, Object.assign({}, props))
    ],
    [
        'small_edit',
        (props)=>jsxRuntime.jsx(SmallEdit, Object.assign({}, props))
    ],
    [
        'small_private',
        (props)=>jsxRuntime.jsx(SmallPrivate, Object.assign({}, props))
    ],
    [
        'small_scrap',
        (props)=>jsxRuntime.jsx(SmallScrap, Object.assign({}, props))
    ],
    [
        'small_heart',
        (props)=>jsxRuntime.jsx(SmallHeart, Object.assign({}, props))
    ],
    [
        'small_public',
        (props)=>jsxRuntime.jsx(SmallPublic, Object.assign({}, props))
    ],
    [
        'small_star',
        (props)=>jsxRuntime.jsx(SmallStar, Object.assign({}, props))
    ],
    [
        'small_more_options',
        (props)=>jsxRuntime.jsx(SmallMoreOptions, Object.assign({}, props))
    ],
    [
        'small_eye',
        (props)=>jsxRuntime.jsx(SmallEye, Object.assign({}, props))
    ],
    [
        'small_trash',
        (props)=>jsxRuntime.jsx(SmallTrash, Object.assign({}, props))
    ],
    [
        'small_share',
        (props)=>jsxRuntime.jsx(SmallShare, Object.assign({}, props))
    ],
    [
        'small_link',
        (props)=>jsxRuntime.jsx(SmallLink, Object.assign({}, props))
    ],
    [
        'small_list',
        (props)=>jsxRuntime.jsx(SmallList, Object.assign({}, props))
    ],
    [
        'small_collection',
        (props)=>jsxRuntime.jsx(SmallCollection, Object.assign({}, props))
    ],
    [
        'small_like',
        (props)=>jsxRuntime.jsx(SmallLike, Object.assign({}, props))
    ],
    [
        'small_bell',
        (props)=>jsxRuntime.jsx(SmallBell, Object.assign({}, props))
    ],
    [
        'small_play',
        (props)=>jsxRuntime.jsx(SmallPlay, Object.assign({}, props))
    ],
    [
        'small_stop',
        (props)=>jsxRuntime.jsx(SmallStop, Object.assign({}, props))
    ],
    [
        'small_slash',
        (props)=>jsxRuntime.jsx(SmallSlash, Object.assign({}, props))
    ],
    [
        'small_cat',
        (props)=>jsxRuntime.jsx(SmallCat, Object.assign({}, props))
    ]
]);
const mediumIcons = new Map([
    [
        'medium_information',
        (props)=>jsxRuntime.jsx(MediumInformation, Object.assign({}, props))
    ],
    [
        'medium_plus',
        (props)=>jsxRuntime.jsx(MediumPlus, Object.assign({}, props))
    ],
    [
        'medium_delete',
        (props)=>jsxRuntime.jsx(MediumDelete, Object.assign({}, props))
    ],
    [
        'medium_eye',
        (props)=>jsxRuntime.jsx(MediumEye, Object.assign({}, props))
    ],
    [
        'medium_arrow_left',
        (props)=>jsxRuntime.jsx(MediumArrowLeft, Object.assign({}, props))
    ],
    [
        'medium_arrow_right',
        (props)=>jsxRuntime.jsx(MediumArrowRight, Object.assign({}, props))
    ],
    [
        'medium_arrow_down',
        (props)=>jsxRuntime.jsx(MediumArrowDown, Object.assign({}, props))
    ],
    [
        'medium_arrow_up',
        (props)=>jsxRuntime.jsx(MediumArrowUp, Object.assign({}, props))
    ],
    [
        'medium_person_add',
        (props)=>jsxRuntime.jsx(MediumPersonAdd, Object.assign({}, props))
    ],
    [
        'medium_caution_triangle',
        (props)=>jsxRuntime.jsx(MediumCautionTriangle, Object.assign({}, props))
    ],
    [
        'medium_bubble',
        (props)=>jsxRuntime.jsx(MediumBubble, Object.assign({}, props))
    ],
    [
        'medium_calendar',
        (props)=>jsxRuntime.jsx(MediumCalendar, Object.assign({}, props))
    ],
    [
        'medium_check',
        (props)=>jsxRuntime.jsx(MediumCheck, Object.assign({}, props))
    ],
    [
        'medium_eye_slash',
        (props)=>jsxRuntime.jsx(MediumEyeSlash, Object.assign({}, props))
    ],
    [
        'medium_edit',
        (props)=>jsxRuntime.jsx(MediumEdit, Object.assign({}, props))
    ],
    [
        'medium_filter',
        (props)=>jsxRuntime.jsx(MediumFilter, Object.assign({}, props))
    ],
    [
        'medium_reset',
        (props)=>jsxRuntime.jsx(MediumReset, Object.assign({}, props))
    ],
    [
        'medium_success',
        (props)=>jsxRuntime.jsx(MediumSuccess, Object.assign({}, props))
    ],
    [
        'medium_caution',
        (props)=>jsxRuntime.jsx(MediumCaution, Object.assign({}, props))
    ],
    [
        'medium_wait',
        (props)=>jsxRuntime.jsx(MediumWait, Object.assign({}, props))
    ],
    [
        'medium_error',
        (props)=>jsxRuntime.jsx(MediumError, Object.assign({}, props))
    ],
    [
        'medium_menu_down',
        (props)=>jsxRuntime.jsx(MediumMenuDown, Object.assign({}, props))
    ],
    [
        'medium_menu_up',
        (props)=>jsxRuntime.jsx(MediumMenuUp, Object.assign({}, props))
    ],
    [
        'medium_heart',
        (props)=>jsxRuntime.jsx(MediumHeart, Object.assign({}, props))
    ],
    [
        'medium_star',
        (props)=>jsxRuntime.jsx(MediumStar, Object.assign({}, props))
    ],
    [
        'medium_highlight',
        (props)=>jsxRuntime.jsx(MediumHighlight, Object.assign({}, props))
    ],
    [
        'medium_more_options',
        (props)=>jsxRuntime.jsx(MediumMoreOptions, Object.assign({}, props))
    ],
    [
        'medium_rename',
        (props)=>jsxRuntime.jsx(MediumRename, Object.assign({}, props))
    ],
    [
        'medium_pin',
        (props)=>jsxRuntime.jsx(MediumPin, Object.assign({}, props))
    ],
    [
        'medium_trash',
        (props)=>jsxRuntime.jsx(MediumTrash, Object.assign({}, props))
    ],
    [
        'medium_hashtag',
        (props)=>jsxRuntime.jsx(MediumHashTag, Object.assign({}, props))
    ],
    [
        'medium_magic',
        (props)=>jsxRuntime.jsx(MediumMagic, Object.assign({}, props))
    ],
    [
        'medium_share',
        (props)=>jsxRuntime.jsx(MediumShare, Object.assign({}, props))
    ],
    [
        'medium_ai',
        (props)=>jsxRuntime.jsx(MediumAi, Object.assign({}, props))
    ],
    [
        'medium_glasses_minus',
        (props)=>jsxRuntime.jsx(MediumGlassesMinus, Object.assign({}, props))
    ],
    [
        'medium_glasses_plus',
        (props)=>jsxRuntime.jsx(MediumGlassesPlus, Object.assign({}, props))
    ],
    [
        'medium_upload',
        (props)=>jsxRuntime.jsx(MediumUpload, Object.assign({}, props))
    ],
    [
        'medium_send',
        (props)=>jsxRuntime.jsx(MediumSend, Object.assign({}, props))
    ],
    [
        'medium_popular',
        (props)=>jsxRuntime.jsx(MediumPopular, Object.assign({}, props))
    ],
    [
        'medium_scrap',
        (props)=>jsxRuntime.jsx(MediumScrap, Object.assign({}, props))
    ],
    [
        'medium_link',
        (props)=>jsxRuntime.jsx(MediumLink, Object.assign({}, props))
    ],
    [
        'medium_search',
        (props)=>jsxRuntime.jsx(MediumSearch, Object.assign({}, props))
    ],
    [
        'medium_minus',
        (props)=>jsxRuntime.jsx(MediumMinus, Object.assign({}, props))
    ],
    [
        'medium_question',
        (props)=>jsxRuntime.jsx(MediumQuestion, Object.assign({}, props))
    ],
    [
        'medium_answer',
        (props)=>jsxRuntime.jsx(MediumAnswer, Object.assign({}, props))
    ],
    [
        'medium_question_new',
        (props)=>jsxRuntime.jsx(MediumQuestionNew, Object.assign({}, props))
    ],
    [
        'medium_list',
        (props)=>jsxRuntime.jsx(MediumList, Object.assign({}, props))
    ],
    [
        'medium_collection',
        (props)=>jsxRuntime.jsx(MediumCollection, Object.assign({}, props))
    ],
    [
        'medium_fire',
        (props)=>jsxRuntime.jsx(MediumFire, Object.assign({}, props))
    ],
    [
        'medium_compass',
        (props)=>jsxRuntime.jsx(MediumCompass, Object.assign({}, props))
    ],
    [
        'medium_public',
        (props)=>jsxRuntime.jsx(MediumPublic, Object.assign({}, props))
    ],
    [
        'medium_private',
        (props)=>jsxRuntime.jsx(MediumPrivate, Object.assign({}, props))
    ],
    [
        'medium_bell',
        (props)=>jsxRuntime.jsx(MediumBell, Object.assign({}, props))
    ],
    [
        'medium_reply',
        (props)=>jsxRuntime.jsx(MediumReply, Object.assign({}, props))
    ]
]);
const largeIcons = new Map([
    [
        'large_delete',
        (props)=>jsxRuntime.jsx(LargeDelete, Object.assign({}, props))
    ],
    [
        'large_service',
        (props)=>jsxRuntime.jsx(LargeService, Object.assign({}, props))
    ],
    [
        'large_account_setting',
        (props)=>jsxRuntime.jsx(LargeAccountSetting, Object.assign({}, props))
    ],
    [
        'large_user_image_avatar',
        (props)=>jsxRuntime.jsx(LargeUserImageAvatar, Object.assign({}, props))
    ],
    [
        'large_arrow_left',
        (props)=>jsxRuntime.jsx(LargeArrowLeft, Object.assign({}, props))
    ],
    [
        'large_arrow_right',
        (props)=>jsxRuntime.jsx(LargeArrowRight, Object.assign({}, props))
    ],
    [
        'large_arrow_down',
        (props)=>jsxRuntime.jsx(LargeArrowDown, Object.assign({}, props))
    ],
    [
        'large_arrow_up',
        (props)=>jsxRuntime.jsx(LargeArrowUp, Object.assign({}, props))
    ],
    [
        'large_bell',
        (props)=>jsxRuntime.jsx(LargeBell, Object.assign({}, props))
    ],
    [
        'large_drawer',
        (props)=>jsxRuntime.jsx(LargeDrawer, Object.assign({}, props))
    ],
    [
        'large_plus',
        (props)=>jsxRuntime.jsx(LargePlus, Object.assign({}, props))
    ],
    [
        'large_filter',
        (props)=>jsxRuntime.jsx(LargeFilter, Object.assign({}, props))
    ],
    [
        'large_search',
        (props)=>jsxRuntime.jsx(LargeSearch, Object.assign({}, props))
    ],
    [
        'large_heart',
        (props)=>jsxRuntime.jsx(LargeHeart, Object.assign({}, props))
    ],
    [
        'large_star',
        (props)=>jsxRuntime.jsx(LargeStar, Object.assign({}, props))
    ],
    [
        'large_share',
        (props)=>jsxRuntime.jsx(LargeShare, Object.assign({}, props))
    ],
    [
        'large_send',
        (props)=>jsxRuntime.jsx(LargeSend, Object.assign({}, props))
    ],
    [
        'large_reset',
        (props)=>jsxRuntime.jsx(LargeReset, Object.assign({}, props))
    ],
    [
        'large_collection',
        (props)=>jsxRuntime.jsx(LargeCollection, Object.assign({}, props))
    ],
    [
        'large_collection_add',
        (props)=>jsxRuntime.jsx(LargeCollectionAdd, Object.assign({}, props))
    ],
    [
        'large_question',
        (props)=>jsxRuntime.jsx(LargeQuestion, Object.assign({}, props))
    ],
    [
        'large_answer',
        (props)=>jsxRuntime.jsx(LargeAnswer, Object.assign({}, props))
    ],
    [
        'large_scrap',
        (props)=>jsxRuntime.jsx(LargeScrap, Object.assign({}, props))
    ],
    [
        'large_like',
        (props)=>jsxRuntime.jsx(LargeLike, Object.assign({}, props))
    ],
    [
        'large_bubble',
        (props)=>jsxRuntime.jsx(LargeBubble, Object.assign({}, props))
    ],
    [
        'large_link',
        (props)=>jsxRuntime.jsx(LargeLink, Object.assign({}, props))
    ],
    [
        'large_home',
        (props)=>jsxRuntime.jsx(LargeHome, Object.assign({}, props))
    ],
    [
        'large_top',
        (props)=>jsxRuntime.jsx(LargeTop, Object.assign({}, props))
    ]
]);
const socialIcons = new Map([
    [
        'social_google',
        (props)=>jsxRuntime.jsx(SocialGoogle, Object.assign({}, props))
    ],
    [
        'social_facebook',
        (props)=>jsxRuntime.jsx(SocialFacebook, Object.assign({}, props))
    ],
    [
        'wishket_facebook',
        (props)=>jsxRuntime.jsx(WishketFacebook, Object.assign({}, props))
    ],
    [
        'wishket_blog',
        (props)=>jsxRuntime.jsx(WishketBlog, Object.assign({}, props))
    ],
    [
        'wishket_naver_blog',
        (props)=>jsxRuntime.jsx(WishketNaverBlog, Object.assign({}, props))
    ],
    [
        'social_x',
        (props)=>jsxRuntime.jsx(SocialX, Object.assign({}, props))
    ],
    [
        'social_naver',
        (props)=>jsxRuntime.jsx(SocialNaver, Object.assign({}, props))
    ],
    [
        'social_linked_in',
        (props)=>jsxRuntime.jsx(SocialLinkedIn, Object.assign({}, props))
    ]
]);

exports.largeIcons = largeIcons;
exports.mediumIcons = mediumIcons;
exports.smallIcons = smallIcons;
exports.socialIcons = socialIcons;
